module.exports = __webpack_public_path__ + "static/media/S (90).ef07fe06.jpg";